import { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Icons 

import {
  FaLeaf,
  FaAward,
  FaGlobe,
  FaShieldAlt,
  FaHandshake,
} from "react-icons/fa";


// Comp--------------------------------------------------->
import About from "../components/about"

// Banner Image --------------------------------------------------------->

import banner01 from "../assets/img/banner/Sustainable-Manufacturing.png"
import banner02 from "../assets/img/banner/Innovation-and-Quality.png"
import banner03 from "../assets/img/banner/Eco-Friendly-Products.png"

// Overview ------------------------------------------------->

import overview01 from "../assets/img/overview/Company-Introduction.jpg"
import overview02 from "../assets/img/overview/Core-Values.jpg"
import overview05 from "../assets/img/overview/Global-Expertise.jpg"
import overview04 from "../assets/img/overview/Manufacturing-Excellence.jpg"
import overview03 from "../assets/img/overview/Sustainability.jpg"

gsap.registerPlugin(ScrollTrigger);


// SLider -------------------------->

const slides = [
   {
    title: "Eco-friendly products",
    text: "Our products are designed with sustainability and environmental responsibility in mind.",
    image: banner03
  },
  {
    title: "Innovation and Quality",
    text: "We combine innovative technology with high-quality standards to create reliable products.",
    image: banner02
  },
  {
    title: "Sustainable manufacturing",
    text: "We focus on responsible manufacturing processes that reduce waste and protect our environment.",
    image: banner01
  },
];

// Overview-------------------------->

const overviewItems = [
  {
    number: "01",
    title: "Company Introduction",
    text: `Middle East Factories is a subsidiary of Middle East Group
    Holdings LLC established in 2008. Indian operations are primarily
    focused on manufacturing and sourcing sustainable, eco-friendly
    products and solutions for consumer and industrial requirements.`,
    image: overview01,
  },
  {
    number: "02",
    title: "Core Values",
    text: `Driven by innovation, guided by responsibility, and committed
    to creating shared value, we grow together with our customers,
    employees, partners, and stakeholders to build a sustainable future.`,
    image: overview02,
  },
  {
    number: "03",
    title: "Commitment to Sustainability",
    text: `Sustainability is at the core of everything we do. We provide
    eco-friendly packaging solutions that help businesses reduce their
    environmental footprint while supporting a circular economy through
    responsible sourcing and recyclable materials.`,
    image: overview03,
  },
  {
    number: "04",
    title: "Manufacturing Excellence",
    text: `Our advanced manufacturing processes ensure consistent quality,
    durability, and precision in every product we produce. With stringent
    quality standards and efficient production capabilities, we deliver
    reliable packaging solutions tailored to diverse industry needs.`,
    image: overview04,
  },
  {
    number: "05",
    title: "Global Expertise",
    text: `With extensive industry experience and a global perspective,
    we provide sustainable packaging solutions that meet international
    quality and compliance standards. We partner with businesses across
    diverse markets, delivering innovative solutions for evolving
    customer needs.`,
    image: overview05,
  },
];

// ////////// Why Choose us ----------------------------------------------------->

const whyChooseUs = [
  {
    icon: <FaLeaf/>,
    title: "Sustainable Products",
    text: "Our portfolio includes high-quality paper bags and sustainable packaging products designed to replace conventional plastic alternatives.",
  },
  {
    icon: <FaAward/>,
    title: "Quality Manufacturing",
    text: "We combine advanced manufacturing technology with rigorous quality control to produce packaging solutions that meet the highest industry standards.",
  },
  {
    icon: <FaGlobe/>,
    title: "Global Sourcing",
    text: "Our strong global sourcing network enables us to procure premium raw materials from trusted suppliers worldwide. This ensures consistent quality, competitive pricing, and a dependable supply chain.",
  },
  {
    icon: <FaShieldAlt/>,
    title: "Environmental Compliance",
    text: "We adhere to national and international environmental regulations and promote responsible manufacturing practices across our operations.",
  },
  {
    icon: <FaHandshake/>,
    title: "Customer-Centric Approach",
    text: "We work closely with our customers to understand their unique packaging requirements and deliver tailored, value-driven solutions. From product design to on-time delivery, we are committed to exceptional service and long-term partnerships.",
  },
];

function Home() {
// About Us
const aboutRef = useRef(null);
const panelRef = useRef([]);
const [activeOverview, setActiveOverview] = useState(0);
// Home Page Slider
const sectionRef = useRef(null);
const slidesRef = useRef([]);

// Why Choose Us
const whyRef = useRef(null);
const whyCardsRef = useRef([]);
useEffect(() => {
  const ctx = gsap.context(() => {
    const slides = slidesRef.current.filter(Boolean);

    if (!slides.length) return;

    const backgrounds = slides.map((slide) =>
      slide.querySelector(".sustainability-slide-bg")
    );

    // Initial state
    gsap.set(slides, {
      autoAlpha: 0,
    });

    gsap.set(slides[0], {
      autoAlpha: 1,
    });

    gsap.set(backgrounds, {
      scale: 1.05,
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top top",

        // Shorter total scroll distance
        end: `+=${window.innerHeight * (slides.length - 1) * 0.8}`,

        // Faster response to scrolling
        scrub: 0.25,

        pin: true,
        anticipatePin: 1,

        // Better mobile refresh behavior
        invalidateOnRefresh: true,
      },
    });

    slides.forEach((slide, index) => {
      if (index === 0) return;

      const previous = slides[index - 1];
      const background = backgrounds[index];

      const currentContent = slide.querySelector(".container-fluid");
      const previousContent = previous.querySelector(".container-fluid");

      // Previous slide out
tl.to(previousContent, {
  y: -60,
  autoAlpha: 0,
  duration: 0.25,
  ease: "power2.in",
});

// Completely hide previous slide
tl.set(previous, {
  autoAlpha: 0,
});

// Current slide
tl.set(slide, {
  autoAlpha: 1,
});

// Current content starts below
tl.fromTo(
  currentContent,
  {
    y: 60,
    autoAlpha: 0,
  },
  {
    y: 0,
    autoAlpha: 1,
    duration: 0.35,
    ease: "power3.out",
  }
);
      // Background zoom
      if (background) {
        tl.fromTo(
          background,
          {
            scale: 1.08,
          },
          {
            scale: 1,
            duration: 0.8,
            ease: "power2.out",
          },
          "<"
        );
      }

      // Very short hold
      tl.to({}, {
        duration: 0.2,
      });
    });

  }, sectionRef);

  return () => ctx.revert();
}, []);

useEffect(() => {

  const ctx = gsap.context(() => {

    /* =========================================
       ABOUT US
    ========================================= */
   
    const panels = panelRef.current.filter(Boolean);

if (panels.length) {
  gsap.set(panels, {
    autoAlpha: 0,
    y: 60,
    force3D: true,
  });

  gsap.set(panels[0], {
    autoAlpha: 1,
    y: 0,
  });

  panels.slice(1).forEach((panel, i) => {
    const index = i + 1;

    gsap.to(panel, {
      autoAlpha: 1,
      y: 0,
      ease: "none",
      scrollTrigger: {
        trigger: panel,
        start: "top 70%",
        end: "top 30%",
        scrub: 0.4,

        onEnter: () => setActiveOverview(index),
        onEnterBack: () => setActiveOverview(index),
      },
    });
  });
}


    /* =========================================
       WHY CHOOSE US
    ========================================= */

    const whyCards = whyCardsRef.current.filter(Boolean);

    if (whyCards.length) {
      gsap.fromTo(
        whyCards,
        {
          opacity: 0,
          y: 60,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: "power3.out",

          scrollTrigger: {
            trigger: whyRef.current,
            start: "top 70%",
            once: true,
          },
        }
      );
    }

  });

  return () => ctx.revert();

}, []);

  return (
    <section>
        {/*///////////Hero Section ----------------------------------------  */}

        <About/>

      {/* ///////Banner---------------------------------------------- */}
       <div ref={sectionRef} className="sustainability-section">

  <div className="sustainability-slider">

    {slides.map((slide, index) => (
      <div
        key={index}
        ref={(el) => {
          slidesRef.current[index] = el;
        }}
        className="sustainability-slide"
      >

        {/* Background image */}
        <div
          className="sustainability-slide-bg"
          style={{
            backgroundImage: `url(${slide.image})`,
          }}
        />

        {/* Gradient overlay */}
        <div className="sustainability-overlay" />

        {/* Content */}
        <div className="container-fluid h-100 px-4 px-lg-5">
          <div className="row h-100 align-items-end pb-30">

            <div className="col-lg-8 col-xl-7 pb-5 pb-lg-6">
              <h1 className="sustainability-title text-white fw-bold">
                {slide.title}
              </h1>

              <p className="sustainability-text text-white">
                {slide.text}
              </p>

            </div>

          </div>
        </div>

      </div>
    ))}

  </div>

</div>
        {/* ///////Company overview---------------------------------------------- */}
        
        <div
          ref={aboutRef}
          className="p-5 company-overview bg-light"
        >
          <div class="background_split-circle is-home_join"></div>
          <Container fluid className="px-4 px-lg-5">
            <Row>
              {/* Sticky left side */}
              <Col
                lg={4}
                className="company-sidebar d-flex flex-column justify-content-center"
              >
                <span className="text-uppercase small fw-semibold">
                  About us
                </span>

                <h2 className="display-4 fw-bold mt-3 text-dark-blue">
                  Company
                  <br />
                  Overview
                </h2>

                <p className="text-secondary mt-3" style={{ maxWidth: "300px" }}>
                  Building a sustainable future through innovation,
                  responsibility and quality.
                </p>

                {/* Progress */}
                {/* <div className="overview-progress mt-5">
                  {overviewItems.map((item, index) => (
                    <div
                      key={index}
                     className={`overview-progress-item ${
        activeOverview === index ? "active" : ""
      }`}
                    >
                      <span className="item">{item.number}</span>
                      <span className="progress-line" />
                    </div>
                  ))}
                </div> */}
              </Col>

              {/* Right content */}
              <Col lg={8} className="pdm-0">

                <div className="overview-content">

                  {overviewItems.map((item, index) => (
                    <div
                      key={index}
                      ref={(el) => {
                        panelRef.current[index] = el;
                      }}
                      className="overview-item"
                    >

                      <div
                        className="overview-image"
                        style={{
                          backgroundImage: `url(${item.image})`,
                        }}
                      />

                      <div className="overview-text">

                        {/* <span className="display-6 fw-bold text-blue-light">
                          {item.number}
                        </span> */}

                        <h3 className="display-6 text-white fw-semibold mt-3">
                          {item.title}
                        </h3>

                        <p className="lead mt-4 text-blue-light">
                          {item.text}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* ////////Why Choose Us ----------------------------------------------*/}

        <div ref={whyRef} className="p-5 py-6 py-lg-6 bg-blue-light">
            <Container fluid className="px-4 px-lg-5">
              {/* Heading */}
              <Row className="mb-5 mb-lg-6">
                <Col lg={6}>
                  <span className="text-uppercase small fw-semibold text-dark">
                    Why choose us
                  </span>

                  <h2 className="display-4 fw-bold mt-3 mb-0 text-dark-blue">
                    Built around quality,
                    <br />
                    sustainability & trust.
                  </h2>
                </Col>

                <Col lg={4} className="ms-auto">
                  <p className="lead text-dark">
                    We combine sustainable thinking, manufacturing excellence
                    and global expertise to deliver packaging solutions that
                    create lasting value.
                  </p>
                </Col>
              </Row>

              {/* Cards */}
              <Row className="g-4">
                {whyChooseUs.map((item, index) => (
                  <Col
                    key={index}
                    md={6}
                    lg={4}
                    className="why-card"
                    ref={(el) => {
                      whyCardsRef.current[index] = el;
                    }}
                  >
                    <div className="h-100 border p-4 p-lg-5">

                      {/* Icon */}
                      <div className="why-icon mb-5">
                        {item.icon}
                      </div>

                      {/* Number */}
                      {/* <span className="small text-dark">
                        0{index + 1}
                      </span> */}

                      <h3 className="h4 fw-semibold mt-3 mb-3">
                        {item.title}
                      </h3>

                      <p className="text-secondary mb-0">
                        {item.text}
                      </p>

                    </div>
                  </Col>
                ))}
              </Row>
            </Container>
          </div>
    </section>
  )
}
export default Home;